import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { NavigationLink, NavigationLinkProps } from '../navigation/NavigationLink';
import './LinkWithIconLeft.scss';

type Props = NavigationLinkProps & {
    readonly theme?: 'warning';
};

const LinkWithIconLeft = forwardRef<HTMLAnchorElement, Props>(({ theme, className, children, ...linkProps }, ref) => {
    return (
        <NavigationLink
            {...linkProps}
            ref={ref}
            className={classNames('link-with-icon-left', theme && `link-with-icon-left--${theme}`, className)}
        >
            {children}
        </NavigationLink>
    );
});

export default LinkWithIconLeft;
